<template>
  <v-system-bar
    v-if="enabled"
    app
    :color="message.type"
    dark
    height="50"
    width="100%"
    window
  >
    <v-alert
      v-model="enabled"
      class="c-sysalert"
      close="mdi-close-circle"
      dismissible
      elevation="0"
      :icon="messageIcon"
      tile
      :type="messageType"
    >
      {{ messageText }}
    </v-alert>
  </v-system-bar>
</template>

<script>
export default {
  name: 'AppSystemBar',

  components: {},

  props: {
    message: {
      type: Object,
      required: false,
      default: function () {
        return {}
      }
    }
  },

  data: function () {
    return {
      enabled: false
    }
  },

  computed: {
    messageIcon() {
      return this.message.icon || undefined
    },

    messageText() {
      return this.message.text[this.$store.state.i18nStore.locale]
    },

    messageType() {
      return this.message.type
    }
  }
}
</script>

<style scoped>
.c-sysalert {
  font-size: 1rem;
  margin: 0;
  padding: 4px;
  font-style: italic;
  color: var(--v-primary--text);
  width: 100%;
}
</style>
